import React, { useState, useRef, useEffect, useContext } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { fetchWithDefaults } from '../../../config/fetchDefault';
import { fetchPdf, sanitizeTextMessage } from '../../../utilities/messagingFunctions';
import { gatherConversation, travelPathway } from '../../../utilities/conversationFunctions';
import { formatPhoneNumber, formatTimestamp } from '../../../utilities/dashFunction';
import TextInputBar from './textBar';
import { useDispatch, useSelector } from 'react-redux';
import { fileServer, prodBackend } from '../../../config/commUrls';
import Icon from '../../../assets/icons/icon';
import { removeSocketListener, getSocket } from '../../../sockets';
import Tooltip from '../../../utilities/helperComponents/tooltip';
import { getConversations } from '../../../utilities/appSetup';
import { decodeJsonFix } from '../../../utilities/jsonUtil'
import { useDebouncedCallback } from 'use-debounce';
import { decrementUnreadMessages, setConvoId, updateTextingNumbers } from '../../../features/conversationSlice';
import { inputMask } from '../../../utilities/genericUtils';
import AgentActivity from '../../activity/agentActivity';
import { AgentContext } from '../../../context/AgentContext';
import BrandedButton, { brandedButtonTypes } from '../../../utilities/inputComponents/BrandedButton';
import Addition from '../../../svgIcon/Addition';

const SMS_OPT_OUT_TAG = 'SMS OPT-OUT';

function QueueConvo({ selectedNumber, refreshLeadData, handleLeadData, expiration, setLoading, from, textingNumbers, conversations, setConversations, canMessageTCPA, setCanMessageTCPA }) {
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const isFeature875Enabled = process.env.REACT_APP_FUNNEL_FEATURE_875 === 'true'
    const isFeature1042Enabled = process.env.REACT_APP_FUNNEL_FEATURE_1042 === 'true'
    const agentInfo = useSelector((state) => state.agent.userData);
    const [addConvo, setAddConvo] = useState(false);
    const texts = useSelector((state) => state.texts.texts);
    const [textsTemplates, setTextsTemplates] = useState(false);
    const [suggestionUse, setSuggestionUse] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [fromNumber, setFromNumber] = useState(false);
    const [theirNumbers, setTheirNumbers] = useState(false);
    const [newConvo, setNewConvo] = useState([]);
    const [toNumber, setToNumber] = useState(false);
    const [currentConvoId, setCurrentConvoId] = useState(false);
    const [convoDisplay, setConvoDisplay] = useState(1);
    const [cursorPosition, setCursorPosition] = useState(0);
    const [attachedImage, setAttachedImage] = useState(false);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [textTemplates, setTextTemplates] = useState(false);
    const [variables, setVariables] = useState(false);
    const [textBoxHeight, setTextBoxHeight] = useState(from==='leadCard' ? 90 : 250);
    const keysWithValue = [];
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTexts, setFilteredTexts] = useState([]);
    const [num, setNum] = useState([]);
    const [smsOptedOut, setSmsOptedOut] = useState(false);
    const [islandlineNumber , setIsLandlneNumber] = useState(false)
    const dispatch = useDispatch()

    const agentTextingNumbers = useSelector((state) => state.agent.textingNumbers)

    const varsToUse=['pdf','borrower_first','borrower_last', 'email', 'address','city','state','zip','mortgage','borrower_occupation','hobby','lender','loan_type','motivation','payment','policy','policy_number','policy_plan','tobacco','height','weight','borrower_age','borrower_dob','borrower_sex','co_borrower_first','co_borrower_last','co_borrower_age','co_borrower_dob','co_borrower_email','co_borrower_occupation'];
    const [disableIntroTextButton, setDisableIntroTextButton] = useState(false)
    const openvars=()=>{
        if(canMessageLead===false){
            return
        }

        setVariables(!variables);
    }
    const keysandvalues = () => {

        if (leadsAlldata.custom_fields !== '') {
            const custom= decodeJsonFix(leadsAlldata.custom_fields);
            for (const key in custom) {
                if (custom[key] !== null && custom[key] !== undefined) {
                    const newkey = key.replaceAll('borrower', 'Lead');
                    keysWithValue.push({ key: newkey, value: custom[key] });
                }
            }
            for (const key in leadsAlldata) {
                if (leadsAlldata[key] !== null && leadsAlldata[key] !== undefined && varsToUse.includes(key)) {
                    const newkey = key.replaceAll('borrower', 'Lead');
                    keysWithValue.push({ key: newkey, value: leadsAlldata[key] });
                }
            }
        }
        else {
            for (const key in leadsAlldata) {
                if (leadsAlldata[key] !== null && leadsAlldata[key] !== undefined && varsToUse.includes(key)) {
                    const newkey = key.replaceAll('borrower', 'Lead');
                    keysWithValue.push({ key: newkey, value: leadsAlldata[key] });
                }
            }
        }
        // Add agency name to keysWithValue
        if (agentInfo && (agentInfo.agencyName || agentInfo.organizationName)) {
            keysWithValue.push({key: 'Agency Name', value: agentInfo.agencyName || agentInfo.organizationName});
        }
    }
    keysandvalues();
    const handleFileUpload = async (e) => {
        if (canMessageLead===false) {
            return
        }

        const file = e.target.files[0];

        const formData = new FormData();

        formData.append('file', file);

        try {
            const backend_port = process.env.REACT_APP_BACKEND_PORT ? process.env.REACT_APP_BACKEND_PORT : 3333
            const backend_url = process.env.REACT_APP_FUNNEL_HOSTNAME ? process.env.REACT_APP_FUNNEL_HOSTNAME : window.location.hostname
            const csrfToken = await localStorage.getItem('keepMeAlive');
            const response = await fetch(`${backend_url}:${backend_port}/sendImage?lead=${leadsAlldata.lead_id}`, {
                method: 'POST',
                body: formData,
                headers : {'X-CSRF-Token': csrfToken }
            });
            const jsonData = await response.json();
            setAttachedImage(`${fileServer}/mmsImages/${jsonData[0].file}`)
        } catch (error) {
            console.error('Error:', error.message);
        }
    };
    const fileRef1 = useRef(null)
    const fileRef2 = useRef(null)
    const fileRef3 = useRef(null)
    const fileRef4 = useRef(null)

    const handleImageClick = (ref) => {
        if(canMessageLead===false){
            return
        }

        ref.current.click()

    };
    const handleChange = (input) => {
        setInputValue(input);
    };

    const filterEmptyValues = (element1, element2, element3) => {
        const nonEmptyValues = [];
        let setMe = "";

        if (element1 !== null && element1 !== undefined && element1 !== '') {
            nonEmptyValues.push(element1);
            setMe = element1;
        }

        if (element2 !== null && element2 !== undefined && element2 !== '') {
            nonEmptyValues.push(element2);
            if (setMe != '') {
                setMe = element2;
            }
        }

        if (element3 !== null && element3 !== undefined && element3 !== '') {
            nonEmptyValues.push(element3);
            if (setMe != '') {
                setMe = element3;
            }
        }
        return nonEmptyValues;
    };

    const sendText = async (key) => {
        if (canMessageLead===false) {
            return
        }

        const textToSend = sanitizeTextMessage(inputValue)
        if(textToSend !=='' || attachedImage){
            if(suggestionUse){
                await travelPathway(leadsAlldata.lead_id, leadsAlldata.pathway, handleLeadData);
            }
            let toNew = toNumber;
            let fromNew = fromNumber;
            if (typeof fromNew === 'object') {
                fromNew = fromNumber.number;
            }
            if ((!toNew || !fromNew) && currentConvoId) {
                toNew = atob(currentConvoId).split(':')[1];
                fromNew = atob(currentConvoId).split(':')[0];
            }
            if (typeof toNew !== 'string') {
                toNew = '+1' + toNew;
            }
            if (fromNew && fromNew !== '') {

                try {
                    const requestOptions = {
                        method: 'POST',
                        body: JSON.stringify({
                            agent: agentInfo.agentId,
                            to: toNew,
                            from: fromNew,
                            body: textToSend,
                            team: agentInfo.teamId,
                            lead: leadsAlldata.lead_id,
                            image: attachedImage
                        })
                    };

                    const response = await fetchWithDefaults('/sendText', requestOptions);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const jsonData = await response.json();
                    if (jsonData.status === true) {
                        const timestamp = new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
                        const newNotes = `Text Sent - ${timestamp} <div className="previewTextWrapper"><div className="previewTextTitle">View Text</div><div className="previewText">${textToSend}</div></div><br> ${leadsAlldata.notes}`;
                        await gatherConversation(leadsAlldata.lead_id, setConversations, dispatch)
                        await getConversations(agentInfo?.agentId, dispatch);
                        setInputValue('');
                        setAttachedImage(false)
                        handleLeadData('notes', newNotes);
                        setConvoDisplay(1);
                        setAddConvo(false);

                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        }
    }

    const handleHeight = (height) => {
        if (from === 'leadCard') {
            if (height !== 50) {
                setTextBoxHeight(90 + height);
            }
            else {
                setTextBoxHeight(140);
            }
        }
        else {
            if (height !== 50) {
                setTextBoxHeight(160 + height);
            }
            else {
                setTextBoxHeight(210);
            }
        }
    };
    useEffect(() => {
        if (currentConvoId) {
            const socket = getSocket();
            socket.on(`${currentConvoId}`, (message) => {
                const newMessage = {
                    direction: "to",
                    image: "",
                    message: message.message,
                    time: message.time
                }

                const foundIndex = conversations.findIndex(obj => {
                    const key = Object.keys(obj)[0]; // Get the first key of the object
                    return key === currentConvoId;   // Compare the key with currentConvoId
                });

                if (foundIndex !== -1) {
                    // Create a new conversations array by copying the old one
                    const updatedConversations = [...conversations];
                    // Update the found conversation's messages array immutably
                    updatedConversations[foundIndex] = {
                        ...updatedConversations[foundIndex],
                        [currentConvoId]: [
                            newMessage,
                            ...updatedConversations[foundIndex][currentConvoId]
                        ],
                    };

                    // Update the state with the new conversations array
                    setConversations(updatedConversations);

                    // update unread count
                    dispatch(decrementUnreadMessages())
                }
                // If this is a message where the lead opts-out or in to SMS
                // messages, we need to update the lead data to get the latest
                // tags property so that the UI can render accordingly.
                if (refreshLeadData) {
                    refreshLeadData();
                }
            })
        }
        return () => {
            removeSocketListener(`${currentConvoId}`);
        };
    }, [currentConvoId, conversations]);

    function formatConvoId(inputString) {
        //setConvoId(inputString);

        const convoString = atob(inputString);
        // Split the input string based on the colon
        const numbersArray = convoString.split(':');

        // Format each number in the array
        const formattedNumbers = numbersArray.map((number) => {
            return inputMask(number, '(###) ###-####', '#', (r,_m,_p) => {
                const num = r.replace(/\D/g, '')
                return num.length === 11 ? num.substring(1) : num
            })
        });

        // Join the formatted numbers with ' & ' between them
        const result = formattedNumbers.join(' & ');
        //addSocketListener()

        return result;
    }
    const handleCursorPosition = (pos) => {
        setCursorPosition(pos);
    }
    const handleClick = (value, key) => {
        if (canMessageLead===false) {
            return
        }

        if (key === 'pdf') {
            fetchPdf(value, setAttachedImage, setVariables, setLoading);
        }
        else {
            const updatedValue = inputValue.slice(0, cursorPosition) + value + inputValue.slice(cursorPosition);
            handleInputChange(updatedValue);
            setCursorPosition(cursorPosition + value.length);
            setVariables(!variables);
        }
    };


    useEffect(() => {
        setFilteredTexts(texts)
        const numbers = filterEmptyValues(leadsAlldata.borrower_cell, leadsAlldata.borrower_home, leadsAlldata.borrower_work);
        setTheirNumbers(numbers)
        setToNumber(numbers[0]);
        setNewConvo([]);
        setConvoDisplay(1);
    }, [leadsAlldata]);

    useEffect(() => {
        if (conversations.length > 0) {
            Object.keys(conversations[0]).map((key) => (
                setCurrentConvoId(key)

            ))
        }
        else{
            setFromNumber(agentTextingNumbers[0]?.number);
        }

    }, [conversations]);

    const debouncedGatherConversation = useDebouncedCallback(async ()=> await gatherConversation(leadsAlldata.lead_id, setConversations, dispatch))

    useEffect(() => {
        if(!debouncedGatherConversation.isPending()){
            debouncedGatherConversation()
        }
    }, [leadsAlldata.lead_id]);
    useEffect(() => {
        if(selectedNumber){
            const isNumberInSelect = (value) => {
                if (!agentTextingNumbers) return false;
                return agentTextingNumbers.some(number => number.number === value);
            };
            // checking if 'selected number' (smart number selection) is avaialble in the dropdown for text number. if it doesn't exist, it wont set an unavilable number to text from, if it does exist, it will set the smart selected number
            const checkNumber = () => { 
                const valueToCheck = selectedNumber;
                if (isNumberInSelect(valueToCheck)) {
                    setFromNumber(selectedNumber)
                }
                else{
                    setFromNumber(agentTextingNumbers[0]?.number);
                }
            };
            checkNumber();
        }
    }, [selectedNumber]);

    const handleRemoveImage = () => {
        setAttachedImage(false);
    }
    const handleToChange = (event) => {
        // Update the state with the selected value
        setToNumber(event.target.value);
    };
    const handleFromChange = (event) => {
        // Update the state with the selected value
        setFromNumber(event.target.value);
    };
    const showConvo = (index, convo) => {
        setConvoDisplay(index);
        setCurrentConvoId(null);
        setFromNumber(agentTextingNumbers[0]?.number);
    }

    const toggleConvo = (index, convo) => {
        setAddConvo(false)
        setConvoDisplay(index);
        let theNewTo;
        let theNewFrom;
        Object.keys(convo).map((key) => (
            theNewTo = atob(key).split(':')[1],
            theNewFrom = atob(key).split(':')[0],
            setCurrentConvoId(key)
        ))
        setFromNumber(theNewFrom);
        setToNumber(theNewTo);
    }

    const handleEmojiPicker = () => {
        if (canMessageLead===false) {
            return
        }

        setShowEmojiPicker(!showEmojiPicker);
    }
    const handleEmojiSelect = (emoji) => {
        if (canMessageLead===false) {
            return
        }

        setInputValue(inputValue + emoji.native);
    };
    const handleTextTemplates = () => {
        if (canMessageLead===false) {
            return
        }

        setTextTemplates(!textTemplates);
    }
    const handleInputChange = (content) => {
        if (canMessageLead===false) {
            return
        }

        setInputValue(content);
    };
    const addTemplate = (template, images) => {
        if (canMessageLead===false) {
            return
        }

        openTemplates();

        if (images) {
            if (!images.includes('http')) {
                const newImageLink = `${fileServer}/${images}`;
                setAttachedImage(newImageLink);
            } else {
                setAttachedImage(images);
            }
        }

        // Replace null or undefined values in currentLead with ''
        let modifiedContent = Object.entries(leadsAlldata).reduce((content, [key, value]) => {
            const replacement = value != null ? value : ''; // Use != to check for both null and undefined
            return content.replaceAll(new RegExp(`{${key.replace('borrower', 'lead')}}`, 'g'), `${replacement}`);
        }, template || '');

        modifiedContent = modifiedContent.replaceAll(/\\n/g, '<br>');

        if (modifiedContent.includes('{agent_first}')) {
            modifiedContent = modifiedContent.replaceAll(/{agent_first}/g, agentInfo?.firstName || '');
        }
        if (modifiedContent.includes('{agent_last}')) {
            modifiedContent = modifiedContent.replaceAll(/{agent_last}/g, agentInfo?.lastName || '');
        }
        if (modifiedContent.includes('{lead_pdf}')) {
            modifiedContent = modifiedContent.replaceAll(/{lead_pdf}/g, '');
            if (leadsAlldata.pdf) {
                fetchPdf(leadsAlldata.pdf, setAttachedImage, setVariables, setLoading);
            }
        }

        if(modifiedContent.includes('{amount_requested}')){
            modifiedContent = modifiedContent.replaceAll(/{amount_requested}/g, leadsAlldata?.coverage_amount || '');
        }

        // Replace null or undefined values in custom fields with ''
        const custom = decodeJsonFix(leadsAlldata.custom_fields || '{}');
        let modifiedContent2 = Object.entries(custom).reduce((content, [key, value]) => {
            const replacement = value != null ? value : ''; // Use != to check for both null and undefined
            return content.replaceAll(new RegExp(`{${key.replace('borrower', 'lead')}}`, 'g'), `${replacement}`);
        }, modifiedContent);

        handleTextTemplates();
        handleInputChange(inputValue + modifiedContent2);
    }

    const openTemplates = () => {
        if(canMessageLead===false){
            return
        }

        setTextsTemplates(!textsTemplates);
    }
    const filterTexts = (searchTerm) => {
        const filtered = texts.filter(text => text.name.toLowerCase().includes(searchTerm.toLowerCase()));
        setFilteredTexts(filtered);
    };
    const toggleNewConvo = () => {
        setAddConvo(true);
    }
    const sendSuggestion = async (template) => {
        if(canMessageLead===false){
            return
        }
        let modifiedContent = Object.entries(leadsAlldata).reduce((content, [key, value]) => {
            const replacement = value !== null ? value : '';
            return content.replaceAll(new RegExp(`{${key.replace('borrower', 'lead')}}`, 'g'), `${replacement}`);
        }, template);
        if (modifiedContent.includes('{agent_first}')) {
            modifiedContent = modifiedContent.replaceAll(/{agent_first}/g, agentInfo.firstName);
        }
        if (modifiedContent.includes('{agent_last}')) {
            modifiedContent = modifiedContent.replaceAll(/{agent_last}/g, agentInfo.lastName);
        }
        setSuggestionUse(true);
        //travelPathway(lead[0].lead_id, lead[0].pathway);
        handleChange(modifiedContent);
        handleHeight();
        //lead.pathway=null;
    }

    const textInputBarProps = {
        handleHeight,
        handleCursorPosition,
        inputValue,
        handleChange,
    }

    const sendTCPAIntroText = async () => {
        if(canMessageLead === true || disableIntroTextButton === true || !fromNumber || !toNumber){
            return
        }
        setDisableIntroTextButton(true)
        const targetId = "tt_intro_text_1";

        // Merge agentInfo and keysWithValue and adding some of the agent variables in there so we can add variables if needed to the text in the future
        const replacements = {
            agent_first: agentInfo.firstName,
            agent_last: agentInfo.lastName,
            email: agentInfo.email,
            ...Object.fromEntries(keysWithValue.map(({ key, value }) => [key, value]))
        };

        // Find the matching template
        const matchContent = texts.find(t => t.id === targetId)?.content?.replace(/\\n/g, '\n') || "";

        // Replace placeholders with actual values
        const introText = matchContent.replace(/{(\w+)}/g, (_, key) => replacements[key] || `{${key}}`);

        let toNew = toNumber;
        let fromNew = fromNumber;
        if (typeof fromNew === 'object') {
            fromNew = fromNumber.number;
        }

        if (typeof toNew !== 'string') {
            toNew = '+1' + toNew;
        }

        if (fromNew && fromNew !== '') {
            try {
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify({
                        agent: agentInfo.agentId,
                        to: toNew,
                        from: fromNew,
                        body: introText,
                        team: agentInfo.teamId,
                        lead: leadsAlldata.lead_id
                    })
                };

                const response = await fetchWithDefaults('/sendText', requestOptions);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const jsonData = await response.json();
                if (jsonData.status === true) {
                    // let formatedFrom = fromNew.length === 11 `+${fromNew}` ? `+1${fromNew}`
                    let formatedFrom = fromNew.replace(/\D+/g, '')
                    formatedFrom = formatedFrom.length === 11 ? `+${formatedFrom}` : `+1${formatedFrom}`

                    let formatedTo = toNew.replace(/\D+/g, '')
                    formatedTo = formatedTo.length === 11 ? `+${formatedTo}` : `+1${formatedTo}`

                    const newConvId = btoa(formatedFrom + ':' + formatedTo);
                    const timestamp = new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
                    const newNotes = `Text Sent - ${timestamp} <div className="previewTextWrapper"><div className="previewTextTitle">View Text</div><div className="previewText">${introText}</div></div><br> ${leadsAlldata.notes}`;

                    // setConversations([...conversations, { [newConvId]: [jsonData] }])
                    setCurrentConvoId(newConvId)
                    await dispatch(setConvoId(newConvId))

                    await gatherConversation(leadsAlldata.lead_id, setConversations, dispatch)
                    await getConversations(agentInfo?.agentId, dispatch);

                    setInputValue('');
                    setAttachedImage(false)
                    handleLeadData('notes', newNotes);
                    setCanMessageTCPA(true)
                    setAddConvo(false)
                } else {
                    setDisableIntroTextButton(false)
                }
            } catch (error) {
                setDisableIntroTextButton(false)
                console.error('Error fetching data:', error);
            }
        } else {
            setDisableIntroTextButton(false)
        }
    }

    const [showTCPAToolTipTextBox, setShowTCPAToolTipTextBox] = useState(false)
    const [queueConvoWrapperHeight, setQueueConvoWrapperHeight] = useState(50)

    useEffect(() => {
        if (isFeature1042Enabled === true && ((conversations.length < 1) || (isFeature875Enabled === true && conversations.length <= 1 && canMessageTCPA === false))) {
            setQueueConvoWrapperHeight(queueConvoWrapperHeight)
        } else if (from === 'leadCard') {
            setQueueConvoWrapperHeight(40)
        } else if (conversations.length > 1) {
            setQueueConvoWrapperHeight(140)
        }
    }, [conversations, canMessageTCPA, from])

    const [msgTimestampTracker, setMsgTimestampTracker] = useState({})
    const updateMsgTimestampTracker = (msgTs, convoKey) => {
        const key = `${convoKey}-${msgTs}`
        let updatedTracker = {...msgTimestampTracker, ...{[key]: !!!msgTimestampTracker[key]}}

        setMsgTimestampTracker(updatedTracker)
    }
    const unassocNumberRef = useRef()
    const [agentNumNoLongerAvailable, setAgentNumNoLongerAvailable] = useState(false)
    const [canMessageLead, setCanMessageLead] = useState(false)
    const [noPhoneWrapperHeight, setNoPhoneWrapperHeight] = useState(0)

    const checkCurrentConversationAgentNumber = () => {
        if(agentTextingNumbers.length === 0 || !currentConvoId){
            return true
        }

        const convoString = atob(currentConvoId);
        // Split the input string based on the colon
        const numbersArray = convoString.split(':');

        if(!numbersArray[0]){
            return true
        }

        for (let index = 0; index < agentTextingNumbers.length; index++) {
            const {number, friendlyName} = agentTextingNumbers[index];

            if(numbersArray[0] === number || numbersArray[0] === friendlyName){
                return false
            }
        }

        return true
    }

    useEffect(()=>{
        const numberNoLongerAvailable = checkCurrentConversationAgentNumber()
        setAgentNumNoLongerAvailable(numberNoLongerAvailable)

        // adjust convo wrapper based on the visibility of the unassociated div
        if(unassocNumberRef.current){
            // handleHeight((numberNoLongerAvailable ? -1 : 1) * unassocNumberRef.current.clientHeight)
            // console.log({queueConvoWrapperHeight, unassocNumberRef})

            if(numberNoLongerAvailable) {
                setNoPhoneWrapperHeight(queueConvoWrapperHeight + unassocNumberRef.current.clientHeight)
            } else {
                setNoPhoneWrapperHeight(0)
            }
        }

    },[currentConvoId, agentTextingNumbers])

 useEffect(() => {
    //  disable messaging based on explicit business logic
    const shouldDisableMessaging = 
        smsOptedOut || agentNumNoLongerAvailable || (!currentConvoId && !fromNumber && !toNumber) || islandlineNumber
    setCanMessageLead(!shouldDisableMessaging);
}, [smsOptedOut, currentConvoId, fromNumber, toNumber, agentNumNoLongerAvailable , islandlineNumber]);

    useEffect(()=>{
        if(addConvo){
            setToNumber(theirNumbers[0] ? theirNumbers[0].toString() : false) // using false as default value since that is the initial value
            if(!selectedNumber){ // if you add a new conversation, this will use the smart select option if available and turned on
                setFromNumber(agentTextingNumbers[0]?.number ?? false) // using false as default value since that is the initial value

            }
            else{
                setFromNumber(selectedNumber)
            }
            setDisableIntroTextButton(false)
        }
    }, [addConvo])

    useEffect(()=>{
        dispatch(updateTextingNumbers({
            agentNumber: fromNumber,
            leadNumber: toNumber
        }))
    }, [toNumber,fromNumber])

    useEffect(()=>{
        // ensure that the correct agent and lead numbers are set
        // based on the current conversation id
        if(currentConvoId){
            const data = atob(currentConvoId).split(':')

            let entryAgentPhone = data[0]?.replace(/\D/g, '')
            let entryLeadPhone = data[1]?.replace(/\D/g, '')

            if(entryAgentPhone.length === 10){
                entryAgentPhone = `1${entryAgentPhone}`
            }

            if(entryLeadPhone.length === 10){
                entryLeadPhone = `1${entryLeadPhone}`
            }

            dispatch(updateTextingNumbers({
                agentNumber: entryAgentPhone,
                leadNumber: entryLeadPhone
            }))
            setFromNumber(entryAgentPhone)
            setToNumber(entryLeadPhone)
        }
    }, [currentConvoId])

    const {isB2B} = useContext(AgentContext)

    useEffect(
        () => {
            const optedOut = (leadsAlldata.tags || "").trim().toUpperCase().indexOf(SMS_OPT_OUT_TAG) !== -1;
            setSmsOptedOut(optedOut);
            if (optedOut && canMessageLead) {
                setCanMessageLead(false);
            }
        },
        [leadsAlldata]
    );

useEffect(() => {
  const isLandline =
    (leadsAlldata?.no_text || []).some(item => item?.landline === 1) ||
    (leadsAlldata?.tags || "").trim().toUpperCase().includes("LANDLINE");
    setIsLandlneNumber(!!isLandline);
}, [toNumber, leadsAlldata]);

    return (

        <div className="queueConvoWrapper" style={{ height: agentNumNoLongerAvailable
            ? `calc(100% - ${queueConvoWrapperHeight + noPhoneWrapperHeight + 50}px)`
            :  queueConvoWrapperHeight ? `calc(100% - ${queueConvoWrapperHeight + noPhoneWrapperHeight}px)` : null, width: `${from === 'leadCard' ? '100%' : '90%'}` }}>

            <div className="queueConvoHeader">
                {conversations?.length < 1 && (
                    <div className="queueConversationButton">New Conversation</div>
                )}
                {conversations && (
                    <>
                        {conversations.map((convo, index) => (
                            <div key={`conversationBox${index}`} className='queueConversationButton'>
                                <BrandedButton
                                    buttonLabel={`Convo #${index + 1}`}
                                    clickHandler={_ => toggleConvo(index + 1, convo)}
                                    buttonType={convoDisplay === (index + 1) ? brandedButtonTypes.PRIMARY : brandedButtonTypes.SECONDARY}
                                />
                            </div>
                        ))}
                    </>
                )}
            </div>
            {conversations.length < 1 && ((isFeature875Enabled === false) || (isFeature875Enabled === true && canMessageTCPA === true)) ? (
                <div className="queueConversationWrapper" style={{ height: leadsAlldata.pathway ? 'calc(100% - 50px)' : '100%' }}>
                    <div className="conversationTitle">
                        <span className="fromNumWrapper">
                            <select className="numberSelectBox" value={fromNumber} onChange={handleFromChange}>
                                {agentTextingNumbers && (
                                    agentTextingNumbers.map((number, index) => (
                                        <option key={`num${index}`} value={number.number}>{number.friendlyName}</option>
                                    ))
                                )}
                            </select>
                        </span>
                        <span style={{ padding: '0px 5px' }}>&</span>
                        <span className="toNumWrapper">
                            <select className="numberSelectBox" value={toNumber} onChange={handleToChange}>
                                {theirNumbers && (
                                    theirNumbers.map((number, index) => (
                                        <option key={`theirNumber${index}`}>{formatPhoneNumber(number.toString())}</option>
                                    ))
                                )}
                            </select>
                        </span>
                    </div>
                    <div className="queueConversationInnerWrapper" style={{ height: `calc(100% - ${textBoxHeight + 38}px` }}>
                    {newConvo && newConvo.map((message, index) => (
                        <div className={`messageWrapper message${message.direction}`} key={`newConvo${index}`}>
                            {!!msgTimestampTracker[`NEW-${message.time}`] && (
                                <div style={{margin: '0 5px'}}>{formatTimestamp(message.time, agentInfo.timezone)}</div>
                            )}
                            <div onDoubleClick={ _ => updateMsgTimestampTracker(message.time, 'NEW')} className={`convoBubble background${message.direction}`}>
                                {message.image && message.image != 0 && (
                                    <div className="sentImageWrapper">
                                        <img src={message.image} alt="Preview" className="sendingImage"/>
                                    </div>
                                )}
                               {message.message.split('\n').map((line, i) => (
                                    <React.Fragment key={i}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
                    </div>
                    {leadsAlldata.pathway && (
                        <div className="pathSuggestion">
                            <div className="suggestionHolder">
                                <div className="suggestion" onClick={() => sendSuggestion(leadsAlldata.convoFlowContent)}><span className="fontello" style={{ marginTop: '-7px', marginRight: '10px' }}><Icon name={'q-lightning-bolt-fast'} size={24} className="suggestionIcon" adjust="fontello" /></span>{leadsAlldata.convoFlowName}</div>
                            </div>
                        </div>
                    )}
                    <div className="sendingImageWrapper">
                        {attachedImage && (
                            <div className="innerImageWrapper">
                                <div className="removeImage" onClick={() => handleRemoveImage()}>x</div>
                                <img src={attachedImage} alt="Preview" className="sendingImage" />
                            </div>
                        )}
                    </div>
                    {agentNumNoLongerAvailable && (
                        <div ref={(conversations.length < 1 && ((isFeature875Enabled === false) || (isFeature875Enabled === true && canMessageTCPA === true))) ? unassocNumberRef : null} style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 12, paddingBottom: 12, background: '#F95951', overflow: 'hidden', borderRadius: 6, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                            <div style={{justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
                                <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word'}}>Phone Number No Longer Available</span>
                                <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>This phone number is no longer active on your account. Try starting   a new conversation with your current active number.</span>
                            </div>
                            <div style={{width: 18, height: 18, position: 'relative'}}>
                                <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#FFFFFF' viewBox="0 0 1024 700"></Icon>
                            </div>
                        </div>
                    )}
                    {parseInt(expiration) > 0 || !expiration ? (
                        <div className="sendBar">
                            <div className="inputBarWrapper">
                                <TextInputBar {...textInputBarProps} canEditContent={canMessageLead} />
                            </div>
                            <div className={`sendButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => sendText()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'send-q'} height='38' width='30' className="" adjust="fontello" /></span></div>
                            <div className="sendBarOptions">
                                <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}>
                                    <span style={{ fontSize: '30px' }} onClick={() => handleEmojiPicker()}>&#9786;</span>
                                </div>
                                <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => handleImageClick(fileRef1)}>
                                    <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'image-q'} height='38' width='30' className="" adjust="fontello" /></span>
                                    <input
                                        type="file"
                                        ref={fileRef1}
                                        style={{ display: 'none' }}
                                        onChange={(e)=> handleFileUpload(e)}
                                        disabled={canMessageTCPA === false && isFeature875Enabled === true}
                                    />
                                </div>
                                <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}>
                                    {/* <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'clock-q'} height='38' width='30' className="" adjust="fontello" /></span> */}
                                </div>
                                <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openvars()}>
                                    <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'q-brackets-plus'} height='38' width='30' className="" adjust="fontello" /></span>
                                </div>
                                {variables && (
                                    <div className="variableWindow">
                                        <div className="innerWrapper">
                                            {keysWithValue.map((variable, index) => (
                                                <div className="leadInfoLine" key={`variable${index}`}>
                                                    <span className="dataFieldTitle">{variable.key.replace('_', ' ')}</span>
                                                    <span className="leadData" onClick={() => handleClick(variable.value, variable.key)} style={{ cursor: 'pointer' }}>Click To Use</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openTemplates()}>
                                    <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'file-text-q'} height='38' width='30' className="" adjust="fontello" /></span>
                                </div>
                                {textsTemplates && (
                                    <div className="variableWindow">
                                        <input
                                            type="text"
                                            placeholder="Search templates..."
                                            className="templateSearch"
                                            value={searchTerm}
                                            onChange={(e) => {
                                                setSearchTerm(e.target.value);
                                                filterTexts(e.target.value);
                                            }}
                                            disabled={canMessageTCPA === false && isFeature875Enabled === true}
                                        />
                                        <div className="innerWrapper">
                                            {filteredTexts.map((text, index) => (
                                                <div className="leadInfoLine" key={`texttemplate${index}`}>
                                                    <span className="dataFieldTitle">{text.name}</span>
                                                    <span className="leadData" onClick={() => addTemplate(text.content, text.images)} style={{ cursor: 'pointer' }}>Click To Use</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : expiration > -1209600 ? (
                        <div className="expiredText">You can no longer message this lead. You have {Math.round((expiration + 1209600) / 86400)} days left before texting is permanently disabled</div>
                    ) : (
                        <div className="expiredText">You can no longer message this lead</div>
                    )}
                    {showEmojiPicker && (
                        <div className="emojiWrapper" style={{
                            position: 'absolute', bottom: '50px'
                        }} >
                            <Picker
                                data={data} onEmojiSelect={handleEmojiSelect}
                            />
                        </div>
                    )}

                </div>
            ) : addConvo === true ? (
                <div className="queueConversationWrapper" style={{ height: leadsAlldata.pathway ? 'calc(100% - 50px)' : '100%' }}>
                    <div className="conversationTitle">
                        <span className="fromNumWrapper">
                            <select className="numberSelectBox" value={fromNumber} onChange={handleFromChange}>
                                {agentTextingNumbers && (
                                    agentTextingNumbers.map((number, index) => (
                                        <option key={`num${index}`} value={number.number}>{number.friendlyName}</option>
                                    ))
                                )}
                            </select>
                        </span>
                        &
                        <span className="toNumWrapper">
                            <select className="numberSelectBox" value={toNumber} onChange={handleToChange}>
                                {theirNumbers && (
                                    theirNumbers.map((number, index) => (
                                        <option key={`theirNumber${index}`}>{formatPhoneNumber(number.toString())}</option>
                                    ))
                                )}
                            </select>
                        </span>
                    </div>
                    <div className="queueConversationInnerWrapper" style={{ height: `calc(100% - ${textBoxHeight}px` }}>
                    {newConvo && newConvo.map((message, index) => (
                        <div className={`messageWrapper message${message.direction}`} key={`newConvo${index}`}>
                            {!!msgTimestampTracker[`NEW-${message.time}`] && (
                                <div style={{margin: '0 5px'}}>{formatTimestamp(message.time, agentInfo.timezone)}</div>
                            )}
                            <div onDoubleClick={ _ => updateMsgTimestampTracker(message.time, 'NEW')} className={`convoBubble background${message.direction}`}>
                                {message.image && message.image != 0 && (
                                    <div className="sentImageWrapper">
                                        <img src={message.image} alt="Preview" className="sendingImage"/>
                                    </div>
                                )}
                                {message.message.split('\n').map((line, i) => (
                                    <React.Fragment key={i}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
                    </div>
                    <div className="sendingImageWrapper">
                        {attachedImage && (
                            <div className="innerImageWrapper">
                                <div className="removeImage" onClick={() => handleRemoveImage()}>x</div>
                                <img src={attachedImage} alt="Preview" className="sendingImage" />
                            </div>
                        )}
                    </div>
                    <div className="sendBar">
                        <div className="inputBarWrapper">
                            <TextInputBar {...textInputBarProps} canEditContent={disableIntroTextButton === true}/>
                        </div>
                        <div className={`sendButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => sendText()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'send-q'} height='38' width='30' className="" adjust="fontello" /></span></div>
                        <div className="sendBarOptions">
                            <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}><span style={{ fontSize: '30px' }} onClick={() => handleEmojiPicker()}>&#9786;</span></div>
                            <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => handleImageClick(fileRef2)}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'image-q'} height='38' width='30' className="" adjust="fontello" /></span>
                                <input
                                    type="file"
                                    ref={fileRef2}
                                    style={{ display: 'none' }}
                                    onChange={(e)=> handleFileUpload(e)}
                                    disabled={canMessageTCPA === false && isFeature875Enabled === true}
                                />
                            </div>
                            <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openvars()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'q-brackets-plus'} height='38' width='30' className="" adjust="fontello" /></span></div>
                            {variables && (
                                <div className="variableWindow">
                                    <div className="innerWrapper">
                                        {keysWithValue.map((variable, index) => (
                                            <div className="leadInfoLine" key={`variable${index}`}><span className="dataFieldTitle">{variable.key.replace('_', ' ')}</span><span className="leadData" onClick={() => handleClick(variable.value, variable.key)} style={{ cursor: 'pointer' }}>Click To Use</span></div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openTemplates()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'file-text-q'} height='38' width='30' className="" adjust="fontello" /></span></div>
                            {textsTemplates && (
                                <div className="variableWindow">
                                    <input
                                        type="text"
                                        placeholder="Search templates..."
                                        className="templateSearch"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            filterTexts(e.target.value);
                                        }}
                                        disabled={canMessageTCPA === false && isFeature875Enabled === true}
                                    />
                                    <div className="innerWrapper">
                                        {filteredTexts.map((text, index) => (
                                            <div className="leadInfoLine" key={`texttemplate${index}`}>
                                                <span className="dataFieldTitle">{text.name}</span>
                                                <span className="leadData" onClick={() => addTemplate(text.content, text.images)} style={{ cursor: 'pointer' }}>Click To Use</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {showEmojiPicker && (
                        <div className="emojiWrapper" style={{
                            position: 'absolute', bottom: '50px'
                        }} >
                            <Picker
                                data={data} onEmojiSelect={handleEmojiSelect}
                            />
                        </div>
                    )}

                    {canMessageTCPA === false && (
                        <div className={disableIntroTextButton === true || !fromNumber || !toNumber ? 'solidQuilityInactiveButton' : 'solidQuilityActiveButton'} onClick={() => sendTCPAIntroText()} style={{width: 'max-content', padding: '0px 24px', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '20px', cursor: 'pointer'}}>
                            Send Introductory Text Message
                            <span className="fontello" style={{ marginTop: '-7px' }}>
                                <Icon name={'send-q'} height='38' width='30' className="" adjust="fontello" />
                            </span>
                        </div>
                    )}
                </div>
            ) : (!addConvo && conversations.length > 0) ? (
                conversations.map((convo, index) => (
                    <div className={`queueConversationWrapper ${convoDisplay === (index + 1) ? '' : 'hidden'}`} key={`coversation` + (index + 1)} style={{ height: leadsAlldata.pathway ? 'calc(100% - 50px)' : '100%' }}>
                        {Object.keys(convo).map((key) => (
                            <span key={`anotherConvo${key}`}>
                                <div className="conversationTitle" style={{display: 'flex', justifyContent: 'space-between'}}>
                                    {formatConvoId(key)}
                                    {conversations.length > 0 && addConvo === false && (
                                        // <div className={`${isB2B ? 'b2b ' : ''}addNewConvo`} onClick={() => toggleNewConvo()}>+ Convo</div>
                                        <div style={{height: 25}}>
                                            <BrandedButton
                                                buttonLabel='Convo'
                                                buttonType={brandedButtonTypes.TERTIARY}
                                                clickHandler={_ => toggleNewConvo()}
                                                brandedIcon='Addition'
                                                iconStyles={{width: 16, height: 16}}
                                            >
                                                <Addition/>
                                            </BrandedButton>
                                        </div>
                                    )}
                                </div>

                                <div className="queueConversationInnerWrapper" style={{ height: `calc(100% - ${textBoxHeight }px` }}>
                                    {convo[key].map((message, index) => (
                                        message.pending ? (
                                            <div key={`specConfo${index}`} className={`messageWrapper messagefrom`}>
                                                {!!msgTimestampTracker[`${key}-${message.time}`] && (
                                                    <div style={{margin: '0 5px'}}>{formatTimestamp(message.time, agentInfo.timezone)}</div>
                                                )}
                                                <div onDoubleClick={ _ => updateMsgTimestampTracker(message.time, key)} className={`convoBubble backgroundto`}>
                                                    {message.image && message.image != 0 && (
                                                        <div className="sentImageWrapper">
                                                            <img src={message.image} alt="Preview" className="sendingImage" />
                                                        </div>
                                                    )}
                                                    {message.message.split('\n').map((line, i) => (
                                                        <React.Fragment key={i}>
                                                            {line}
                                                            <br />
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <div key={`specConfo${index}`} className={`messageWrapper message${message.direction}`}>
                                                {!!msgTimestampTracker[`${key}-${message.time}`] && (
                                                    <div style={{margin: '0 5px'}}>{formatTimestamp(message.time, agentInfo.timezone)}</div>
                                                )}
                                                <div onDoubleClick={ _ => updateMsgTimestampTracker(message.time, key)} className={`convoBubble background${message.direction}`}>
                                                    {message.image && message.image != 0 && (
                                                        <div className="sentImageWrapper">
                                                            <img src={message.image} alt="Preview" className="sendingImage" />
                                                        </div>
                                                    )}
                                                    {message.message.split('\n').map((line, i) => (
                                                        <React.Fragment key={i}>
                                                            {line}
                                                            <br />
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        )

                                    ))}
                                </div>
                            </span>
                        ))}
                        {!agentNumNoLongerAvailable && leadsAlldata.pathway && (
                            <div className="pathSuggestion">
                                <div className="suggestionHolder">
                                    <div className="suggestion" onClick={() => sendSuggestion(leadsAlldata.convoFlowContent)}><span className="fontello" style={{ marginTop: '-7px', marginRight: '10px' }}><Icon name={'q-lightning-bolt-fast'} size={24} className="suggestionIcon" adjust="fontello" /></span>{leadsAlldata.convoFlowName}</div>
                                </div>
                            </div>
                        )}
                        <div className="sendingImageWrapper">
                            {attachedImage && (
                                <div className="innerImageWrapper">
                                    <div className="removeImage" onClick={() => handleRemoveImage()}>x</div>
                                    <img src={attachedImage} alt="Preview" className="sendingImage" />
                                </div>
                            )}
                        </div>
                        {agentNumNoLongerAvailable && (
                            <div ref={(!addConvo && conversations) ? unassocNumberRef : null} style={{paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, background: '#F95951', overflow: 'hidden', borderRadius: 6, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                                <div style={{justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
                                    <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word'}}>Phone Number No Longer Available</span>
                                    <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>This phone number is no longer active on your account. Try starting   a new conversation your current active number.</span>
                                </div>
                                <div style={{width: 18, height: 18, position: 'relative'}}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#FFFFFF' viewBox="0 0 1024 700"></Icon>
                                </div>
                            </div>
                        )}
                        {smsOptedOut && (
                            <div style={{paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, background: '#F95951', overflow: 'hidden', borderRadius: 6, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                                <div style={{justifyContent: 'center', display: 'flex', flexDirection: 'column', paddingRight: '8px'}}>
                                    <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word'}}>This lead has opted out of texting</span>
                                </div>
                                <div style={{width: 18, height: 18, position: 'relative'}}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#FFFFFF' viewBox="0 0 1024 700"></Icon>
                                </div>
                            </div>
                        )}
                          {islandlineNumber && (
                            <div style={{paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, background: '#F95951', overflow: 'hidden', borderRadius: 6, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                                <div style={{justifyContent: 'center', display: 'flex', flexDirection: 'column', paddingRight: '8px'}}>
                                    <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word'}}>Landline Detected: This phone number cannot send and accept text messages</span>
                                </div>
                                <div style={{width: 18, height: 18, position: 'relative'}}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#FFFFFF' viewBox="0 0 1024 700"></Icon>
                                </div>
                            </div>
                        )}
                        {parseInt(expiration) > 0 || !expiration ? (
                            <div className="sendBar">
                                <div className="inputBarWrapper">
                                    <TextInputBar {...textInputBarProps} canEditContent={canMessageLead} />
                                </div>
                                <div className={`sendButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => sendText()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'send-q'} height='38' width='30' className="" adjust="fontello" /></span></div>
                                <div className="sendBarOptions">
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}><span style={{ fontSize: '30px' }} onClick={() => handleEmojiPicker()}>&#9786;</span></div>
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={()=>handleImageClick(fileRef3)}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'image-q'} height='38' width='30' className="" adjust="fontello" /></span>
                                        <input
                                            type="file"
                                            ref={fileRef3}
                                            style={{ display: 'none' }}
                                            onChange={(e)=> handleFileUpload(e)}
                                            disabled={canMessageTCPA === false && isFeature875Enabled === true}
                                        />
                                    </div>
                                    {/* <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'clock-q'} height='38' width='30' className="" adjust="fontello" /></span></div> */}
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openvars()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'q-brackets-plus'} height='38' width='30' className="" adjust="fontello" /></span></div>
                                    {variables && (
                                        <div className="variableWindow">
                                            <div className="innerWrapper">
                                                {keysWithValue.map((variable, index) => (
                                                    <div className="leadInfoLine" key={`variable${index}`}><span className="dataFieldTitle">{variable.key.replace('_', ' ')}</span><span className="leadData" onClick={() => handleClick(variable.value, variable.key)} style={{ cursor: 'pointer' }}>Click To Use</span></div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openTemplates()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'file-text-q'} height='38' width='30' className="" adjust="fontello" /></span></div>
                                    {textsTemplates && (
                                        <div className="variableWindow">
                                            <input
                                                type="text"
                                                placeholder="Search templates..."
                                                className="templateSearch"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    filterTexts(e.target.value);
                                                }}
                                                disabled={canMessageTCPA === false && isFeature875Enabled === true}
                                            />
                                            <div className="innerWrapper">
                                                {filteredTexts.map((text, index) => (
                                                    <div className="leadInfoLine" key={`texttemplate${index}`}>
                                                        <span className="dataFieldTitle">{text.name}</span>
                                                        <span className="leadData" onClick={() => addTemplate(text.content, text.images)} style={{ cursor: 'pointer' }}>Click To Use</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : expiration > -1209600 ? (
                            <div className="expiredText">You can no longer text this lead. To resume messaging, call them and ask them to text you back to "continue working" together. You have {Math.round((expiration + 1209600) / 86400)} days left to do this before texting is permanently disabled</div>
                        ) : (
                            <div className="expiredText">Your ability to message this lead has been removed.</div>
                        )}
                        {showEmojiPicker && (
                            <div className="emojiWrapper" style={{
                                position: 'absolute', bottom: '50px'
                            }} >
                                <Picker
                                    data={data} onEmojiSelect={handleEmojiSelect}
                                />
                            </div>
                        )}
                    </div>
                ))
            ) : (canMessageTCPA === false && isFeature875Enabled === true && addConvo === false) ? (
                <>
                    <div className="queueConversationWrapper" style={{ height: leadsAlldata.pathway ? 'calc(100% - 50px)' : '100%' }}>
                        <div className="conversationTitle">
                            <span className="fromNumWrapper">
                                <select className="numberSelectBox" value={fromNumber} onChange={handleFromChange}>
                                    {agentTextingNumbers && (
                                        agentTextingNumbers.map((number, index) => (
                                            <option key={`num${index}`} value={number.number}>{number.friendlyName}</option>
                                        ))
                                    )}
                                </select>
                            </span>
                            <span style={{ padding: '0px 5px' }}>&</span>
                            <span className="toNumWrapper">
                                <select className="numberSelectBox" value={toNumber} onChange={handleToChange}>
                                    {theirNumbers && (
                                        theirNumbers.map((number, index) => (
                                            <option key={`theirNumber${index}`}>{formatPhoneNumber(number.toString())}</option>
                                        ))
                                    )}
                                </select>
                            </span>
                        </div>
                        <div className="queueConversationInnerWrapper" style={{ height: `calc(100% - ${textBoxHeight + 38}px ` }}>
                        {newConvo && newConvo.map((message, index) => (
                            <div className={`messageWrapper message${message.direction}`} key={`newConvo${index}`}>
                                {!!msgTimestampTracker[`NEW-${message.time}`] && (
                                    <div style={{margin: '0 5px'}}>{formatTimestamp(message.time, agentInfo.timezone)}</div>
                                )}
                                <div onDoubleClick={ _ => updateMsgTimestampTracker(message.time, 'NEW')} className={`convoBubble background${message.direction}`}>
                                    {message.image && message.image != 0 && (
                                        <div className="sentImageWrapper">
                                            <img src={message.image} alt="Preview" className="sendingImage"/>
                                        </div>
                                    )}
                                    {message.message.split('\n').map((line, i) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        ))}
                        </div>
                        <div className="sendingImageWrapper">
                            {attachedImage && (
                                <div className="innerImageWrapper">
                                    <div className="removeImage" onClick={() => handleRemoveImage()}>x</div>
                                    <img src={attachedImage} alt="Preview" className="sendingImage" />
                                </div>
                            )}
                        </div>
                        {isFeature875Enabled && showTCPAToolTipTextBox && (
                            // the event listeners are needed here to prevent the tooltip from flickering
                            // when hovering over it
                            <div onMouseEnter={() => setShowTCPAToolTipTextBox(true)} onMouseLeave={() => setShowTCPAToolTipTextBox(false)}>
                                <Tooltip
                                    title='Ready to send your first text?'
                                    body={`Click below to send a friendly, TCPA-compliant introductory message explaining why you're reaching out, and giving the client an easy option to opt out if they prefer.`}
                                />
                            </div>
                        )}
                        {parseInt(expiration) > 0 || !expiration ? (
                            <div className="sendBar" onMouseEnter={() => setShowTCPAToolTipTextBox(true)} onMouseLeave={() => setShowTCPAToolTipTextBox(false)}>
                                <div className="inputBarWrapper">
                                    <TextInputBar {...textInputBarProps} canEditContent={canMessageLead} />
                                </div>
                                <div className={`sendButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => sendText()}><span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'send-q'} height='38' width='30' className="" adjust="fontello" /></span></div>
                                <div className="sendBarOptions">
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}>
                                        <span style={{ fontSize: '30px' }} onClick={() => handleEmojiPicker()}>&#9786;</span>
                                    </div>
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={()=>handleImageClick(fileRef4)}>
                                        <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'image-q'} height='38' width='30' className="" adjust="fontello" /></span>
                                        <input
                                            type="file"
                                            ref={fileRef4}
                                            style={{ display: 'none' }}
                                            onChange={(e)=> handleFileUpload(e)}
                                            disabled={!canMessageTCPA}
                                        />
                                    </div>
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`}>
                                        {/* <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'clock-q'} height='38' width='30' className="" adjust="fontello" /></span> */}
                                    </div>
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openvars()}>
                                        <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'q-brackets-plus'} height='38' width='30' className="" adjust="fontello" /></span>
                                    </div>
                                    {variables && (
                                        <div className="variableWindow">
                                            <div className="innerWrapper">
                                                {keysWithValue.map((variable, index) => (
                                                    <div className="leadInfoLine" key={`variable${index}`}>
                                                        <span className="dataFieldTitle">{variable.key.replace('_', ' ')}</span>
                                                        <span className="leadData" onClick={() => handleClick(variable.value, variable.key)} style={{ cursor: 'pointer' }}>Click To Use</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    <div className={`optionButton ${canMessageLead===false ? 'disabled' : ''}`} onClick={() => openTemplates()}>
                                        <span className="fontello" style={{ marginTop: '-7px' }}><Icon name={'file-text-q'} height='38' width='30' className="" adjust="fontello" /></span>
                                    </div>
                                    {textsTemplates && (
                                        <div className="variableWindow">
                                            <input
                                                type="text"
                                                placeholder="Search templates..."
                                                className="templateSearch"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    filterTexts(e.target.value);
                                                }}
                                                disabled={!canMessageTCPA}
                                            />
                                            <div className="innerWrapper">
                                                {filteredTexts.map((text, index) => (
                                                    <div className="leadInfoLine" key={`texttemplate${index}`}>
                                                        <span className="dataFieldTitle">{text.name}</span>
                                                        <span className="leadData" onClick={() => addTemplate(text.content, text.images)} style={{ cursor: 'pointer' }}>Click To Use</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : expiration > -1209600 ? (
                            <div className="expiredText">You can no longer message this lead. You have {Math.round((expiration + 1209600) / 86400)} days left before texting is permanently disabled</div>
                        ) : (
                            <div className="expiredText">You can no longer message this lead</div>
                        )}
                        {showEmojiPicker && (
                            <div className="emojiWrapper" style={{
                                position: 'absolute', bottom: '50px'
                            }} >
                                <Picker
                                    data={data} onEmojiSelect={handleEmojiSelect}
                                />
                            </div>
                        )}

                        <div className={(disableIntroTextButton === true || !fromNumber || !toNumber) ? 'solidQuilityInactiveButton' : 'solidQuilityActiveButton'} onClick={() => sendTCPAIntroText()} style={{width: 'max-content', padding: '0px 24px', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '20px', cursor: 'pointer'}}>
                            Send Introductory Text Message
                            <span className="fontello" style={{ marginTop: '-7px' }}>
                                <Icon name={'send-q'} height='38' width='30' className="" adjust="fontello" />
                            </span>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    );
}
export default QueueConvo;